/*
*
* File JS componente Block Text
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-products.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockProducts = () => {

    //APERTURA E CHIUSURA DEL FILTRO CATEGORIE
    const btnOpen = document.querySelector('.open-filter');
    const wrapperFilter = document.querySelector('.filter-categories');
    const filterContainer = document.querySelector('.filter-categories__container');
    const btnClose = wrapperFilter.querySelector('.close');

    btnOpen.addEventListener('click', () => {
        wrapperFilter.classList.add('open');
    })

    btnClose.addEventListener('click', () => {
        wrapperFilter.classList.remove('open');
    })

    document.addEventListener('click', (event) => {
        if (!filterContainer.contains(event.target) && !btnOpen.contains(event.target)) {
            wrapperFilter.classList.remove('open');
        }
    });

    //GESTIONE DEI FILTRI
    const filters = () => {
        function getParams(paramName) {
            const urlParams = new URLSearchParams(window.location.search);
      
            if (urlParams.has(paramName)) {
                return urlParams.get(paramName);
            }
      
            return null;
        }
      
        function addParams(paramName, paramVal = null, multipleValue = false) {
            if (paramVal === null) {
                return;
            }
      
            let url = new URL(window.location.href);
            const urlParams = new URLSearchParams(window.location.search);
      
            if (urlParams.has(paramName) && multipleValue === true) {
                let currentParamVal = urlParams.get(paramName);
                let comma = currentParamVal === "" ? "" : ",";
                paramVal = currentParamVal + comma + paramVal;
            }
            urlParams.set(paramName, paramVal);
      
            url.search = urlParams.toString().replaceAll("%2C", ",");
            window.history.replaceState(null, null, url);
        }
      
        function delParams(paramName, paramVal = null) {
            let url = new URL(window.location.href);
            let params = new URLSearchParams(window.location.search);
      
            if (params.has(paramName)) {
                params.delete(paramName);
            }
      
            url.search = params.toString().replaceAll("%2C", ",");
            window.history.replaceState(null, null, url);
        }
      
        // Rimuove il check dal filtro e triggera il suo onChange
        function uncheckAndTriggerChange(checkbox) {
            if (!(checkbox instanceof HTMLInputElement) || checkbox.type !== 'checkbox') {
                throw new Error('Provided element is not a checkbox.');
            }
            checkbox.checked = false;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      
        // Init categories
        let selectedCategories = [];
        const existingCategories = getParams('cat');
        if (existingCategories) {
            selectedCategories = existingCategories.split(',');
        }
      
        // Event listener per le checkboxes
        const categoriesInput = document.querySelectorAll('input[type="checkbox"]');
        categoriesInput.forEach((input) => {
            const filterId = input.getAttribute("data-filter");
            input.checked = selectedCategories.includes(filterId)
            input.addEventListener("change", (e) => {
                if (input.checked) {
                    if (!selectedCategories.includes(filterId)) {
                        selectedCategories.push(filterId);
                    }
                } else {
                    selectedCategories = selectedCategories.filter(id => id !== filterId);
                }
            });
        });
      
        // Event listener per il button "Apply"
        function applySelectedFilters() {
            delParams('cat');
          
            if (selectedCategories.length > 0) {
                const categoriesString = selectedCategories.join(',');
                addParams('cat', categoriesString, false);
            }
      
          // Rimuove la pagina corrente per tornare alla prima
            let url = new URL(window.location.href);
            url.pathname = url.pathname.replace(/\/page\/\d+\/?/, '');
            window.location.href = url.toString();
        }
        const applyButton = document.getElementById('apply-filters');
        applyButton.addEventListener('click', () => {
            applySelectedFilters();
        });

        // Gestione reset filtri
        let reset = document.querySelector('.filter-categories__list--reset #reset');
        if (reset) {
            reset.addEventListener("click", (e) => {
                categoriesInput.forEach(c => {
                    c.checked = false;
                });
      
                selectedCategories = [];
      
                delParams('cat');
                window.location.reload();
            });
        }
      
        // Rimozione dei tag "categorie"
        const itemsFiltered = document.querySelectorAll('.chips .close');
        if (itemsFiltered.length > 0) {
            itemsFiltered.forEach((item)=>{
                let itemID = item.dataset.cat;
                item.addEventListener("click", (e) => {
                    let checkbox = document.querySelector(`input[type="checkbox"][id="${itemID}"]`);
                    checkbox.checked = false;
          
                    selectedCategories = selectedCategories.filter(id => id !== itemID);
      
                    applySelectedFilters();
                });
            })
        }
      
        // Controllo ordine prodotti
        const orderSelect = document.getElementById('order');
        orderSelect.addEventListener("change", (e)=>{
            let order = e.target.value;
            
            delParams('order');
            addParams('order', order, false);
            
            window.location.reload();
            
        })
        
        const searchInput = document.getElementById('productsSearch');
        const searchForm = document.getElementById('productsSearchForm');
        searchForm.addEventListener("submit", (e)=>{
            e.preventDefault();
            delParams('keyword');
            console.log(searchInput)
            const searchValue = searchInput.value.trim();
            if (searchValue !== '') {
                addParams('keyword', searchValue, false);
            }
            window.location.reload();
        })
    };
      
    filters();
}

export default blockProducts;

//--------------------------------------------------------------------//